import { Injectable, EventEmitter, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { Configuration } from '../configurations/shared.config';
import { HttpService } from "../services/http.service";
import { ResourceService } from '../services/resource.service';
import { FilterCriteria } from '../dataModels/grid-list';
import { IErrorHandler } from '../dataModels/contracts/IErrorHandler';

@Injectable()
export class CollectionService {

    public collectionReady: EventEmitter<any> = new EventEmitter<any>();
    public gettingCollection: EventEmitter<any> = new EventEmitter<any>();
    private _errorHandler: IErrorHandler;

    constructor(private _http: Http, @Inject("IErrorHandler") handler: IErrorHandler, private _resourceService: ResourceService, private _httpService: HttpService) {
        this._errorHandler = handler;
    }

    loadCollection(postUrl: string, filter: FilterCriteria, loader: boolean = true) {
        if (postUrl != "") {
            this.gettingCollection.emit(true);
            //Request with specific criteria
            this._httpService.post(postUrl, filter, null, loader).subscribe(response => {

                //if Ok
                if (response && response.ok) {

                    //parse to Json object
                    var result = JSON.parse(response.text());

                    //Not in Error State
                    if (result && !result.IsErrorState && result.Value) {

                        //if Collection exists
                        if (result.Value.Collection) {
                            // console.log("result.Value.Collection", result.Value.Collection)
                            //emit collection
                            this.collectionReady.emit(result.Value);
                        }
                    }
                    else {
                        this._resourceService.Localize(Configuration.resources.sharedResourceName, Configuration.messages.defaultErrorMessage);
                    }
                }
                else {
                    this._resourceService.Localize(Configuration.resources.sharedResourceName, Configuration.messages.defaultErrorMessage);
                }

            }, error => {
                this._resourceService.Localize(Configuration.resources.sharedResourceName, Configuration.messages.defaultErrorMessage);
            });
        }
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/collection.service.ts